import {FormVehiculeModel} from './FormVehiculeModel';
import {FormConducteurModel} from './FormConducteurModel';

export class FormModel {
 vehicule: FormVehiculeModel;
 conducteurPrincipal: FormConducteurModel;
 isAjouterConducteurSecondaire: string;
 conducteurSecondaire: FormConducteurModel;
 titulaireCarteGrise: string;
 garantieSouhaiteeConducteurPrincipal: string;
 deviceType: string;
 urlSource: string;
 keyword: string;
 constructor() {
   this.vehicule = new FormVehiculeModel();
   this.conducteurPrincipal = new FormConducteurModel();
   this.conducteurSecondaire = new  FormConducteurModel();
 }
}
